import type {
  MyTimeOffRequestsQueryParams,
  TimeOffDateRangeQueryParams,
  TimeOffTypesQueryParams,
} from '../types';

/**
 * TimeOff is tenant-scoped (unlike Personal Summary/Notes) — every key includes
 * `orgId` so switching organizations invalidates the right cache slice.
 */
export const TIME_OFF_KEYS = {
  all: ['time-off'] as const,
  activationProbe: (orgId: string) => ['time-off', 'activation-probe', orgId] as const,
  policy: (orgId: string) => ['time-off', 'policy', orgId] as const,
  types: (orgId: string, params?: TimeOffTypesQueryParams) =>
    ['time-off', 'types', orgId, params] as const,
  seniorityMatrix: (orgId: string) => ['time-off', 'seniority-matrix', orgId] as const,
  holidays: (orgId: string, year: number) => ['time-off', 'holidays', orgId, year] as const,
  myRequests: (orgId: string, params?: MyTimeOffRequestsQueryParams) =>
    ['time-off', 'me', 'requests', orgId, params] as const,
  request: (orgId: string, requestId: string) =>
    ['time-off', 'requests', orgId, requestId] as const,
  myBalance: (orgId: string) => ['time-off', 'me', 'balance', orgId] as const,
  mySummary: (orgId: string) => ['time-off', 'me', 'summary', orgId] as const,
  approvals: (orgId: string) => ['time-off', 'approvals', orgId] as const,
  team: (orgId: string, params: TimeOffDateRangeQueryParams) =>
    ['time-off', 'team', orgId, params] as const,
  adminSummary: (orgId: string, params: TimeOffDateRangeQueryParams) =>
    ['time-off', 'admin', 'summary', orgId, params] as const,
};
